// Open modal
jQuery( '.open-modal' ).on( 'click', function() {
  const id = jQuery( this ).attr( 'modal-id' );
  document.querySelector( '.modal#' + id ).classList.add( 'active' );
} );

const links = document.querySelectorAll( '[href^="#modal"]' );
links.forEach( link => link.addEventListener( 'click', function( e ) {
  e.preventDefault();
  document.querySelector( link.hash ).classList.add( 'active' );
} ) );

// Close modal on x click
jQuery( '.modal-close' ).on( 'click', function() {
  this.closest( '.modal' ).classList.remove( 'active' );
} );

jQuery( '.modal .modal-content #modalSlider' ).slick( {
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  rows: 0,
  autoplay: true,
  autoplaySpeed: 5000,
  arrows: true,
  prevArrow: jQuery( '.modal .modal-content .arrows .prev' ),
  nextArrow: jQuery( '.modal .modal-content .arrows .next' ),
} );


// Contact form specific
jQuery( function( $ ) {
  const modalForm = document.getElementById( 'modal-contact' );
  const formStep = modalForm.querySelector( '.modal-form__main' );
  const successStep = modalForm.querySelector( '.modal-form__success' );
  const form = formStep.querySelector( '.wpcf7' );
  const submitButton = form.querySelector( '.wpcf7-submit' );

  jQuery( '.modal-close' ).on( 'click', function() {
    formStep.classList.remove( 'inactive' );
    successStep.classList.add( 'inactive' );
  } );

  submitButton.addEventListener( 'click', () => {
    submitButton.classList.add( 'loading' );
  } );

  form.addEventListener( 'wpcf7submit', () => {
    submitButton.classList.remove( 'loading' );
  } );
  form.addEventListener( 'wpcf7mailsent', () => {
    formStep.classList.add( 'inactive' );
    successStep.classList.remove( 'inactive' );
  } );
} );